import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { VoltixLogo } from "@/components/VoltixLogo";

export default function Register() {
  const nav = useNavigate();
  const { register, t } = useApp();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("OK");
      nav("/conta");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro");
    } finally { setLoading(false); }
  };

  return (
    <div className="mx-auto max-w-md px-4 py-16">
      <div className="flex justify-center mb-8"><VoltixLogo /></div>
      <div className="rounded-3xl border border-border p-8 bg-card">
        <h1 className="text-2xl font-display font-bold mb-2">{t("auth.register")}</h1>
        <p className="text-sm text-muted-foreground mb-6">{t("auth.registerSub")}</p>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>{t("auth.name")}</Label><Input required value={form.name} onChange={(e)=>setForm({...form,name:e.target.value})} data-testid="register-name" /></div>
          <div><Label>Email</Label><Input type="email" required value={form.email} onChange={(e)=>setForm({...form,email:e.target.value})} data-testid="register-email" /></div>
          <div><Label>{t("auth.password")}</Label><Input type="password" required minLength={6} value={form.password} onChange={(e)=>setForm({...form,password:e.target.value})} data-testid="register-password" /></div>
          <div><Label>{t("checkout.phone")}</Label><Input value={form.phone} onChange={(e)=>setForm({...form,phone:e.target.value})} /></div>
          <Button type="submit" className="w-full rounded-full btn-primary" disabled={loading} data-testid="register-submit">
            {loading ? "..." : t("cta.register")}
          </Button>
        </form>
        <div className="mt-6 text-sm text-center text-muted-foreground">
          {t("auth.hasAccount")} <Link to="/login" className="text-primary hover:underline">{t("auth.loginLink")}</Link>
        </div>
      </div>
    </div>
  );
}
